import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./ThankYou.css";

function ThankYou() {

  useEffect(() => {
    const ADS_ID = "AW-16824190472";
    const CONVERSION_ID = "AW-16824190472/4kaeCOjii-IbEIiMs9Y-";

    const fireConversion = () => {
      if (window.gtag) {
        window.gtag("event", "conversion", {
          send_to: CONVERSION_ID,
        });
      }
    };

    // If gtag already exists (maybe from another page)
    if (window.gtag) {
      fireConversion();
      return;
    }

    // Load gtag.js
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`;

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag(){ window.dataLayer.push(arguments); }
      window.gtag = gtag;

      gtag("js", new Date());
      gtag("config", ADS_ID);

      // Fire conversion ONLY after gtag is ready
      fireConversion();
    };

    document.head.appendChild(script);

  }, []);

  return (
    <section className="hmslder-sec abt-sec thankyou-sec">
      <div className="breadcrumbs">
        <div className="container">
          <ul>
            <li><Link to="/">Home</Link></li>
            <li>Thank You</li>
          </ul>
        </div>
      </div>

      <div className="container">
        <div className="hmslder-txt">
          <h2>Thank <span>You</span></h2>
          <p>
            We appreciate you getting in touch with us.
            Your request has been submitted successfully and our team will
            contact you shortly.
          </p>

          <Link to="/" className="btn-main">
            <span>Go Back to Home</span>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default ThankYou;
